<template>
  <div class="input-main">
    <div
      v-if="textType == 'text' || textType == 'password' || textType == 'number'"
      class="placeholder"
      :class="[textClass, placeholderClass]"
    >
      <div class="no-wrap" :class="{ 'has-label-suffix': hasLabelSuffixSlot() }" :style="{ paddingRight: isRequired ? '5px' : '0px' }">
        <span v-if="isRequired" style="color: red; margin-right: 5px">**</span> {{ placeholder }}
        <slot name="label-suffix"></slot>
      </div>
    </div>
    <div v-if="textType == 'text' || textType == 'password' || textType == 'number'" class="input-control" :class="{ 'is-disabled': isDisabled }">
      <slot name="prefix"></slot>
      <input
        :type="textType"
        :class="textClass"
        :title="`${placeholder}${inputValue ? `:\n${inputValue}` : ''}`"
        @focus="inputFocusState(true)"
        @blur="inputFocusState(false)"
        v-model="pInputValue"
        :disabled="isDisabled"
        @mouseenter="inputHover = true"
        @mouseleave="inputHover = false"
        @keydown="inputKeyState($event, 'keydown')"
        @keyup="inputKeyState($event, 'keyup')"
        @input="inputChanged"
        ref="myinput"
      />
    </div>
    <div v-if="textType == 'file'" class="file-area">
      <div v-if="isDisabled" class="file-disabled"></div>
      <div class="upload-area">
        <span v-if="isRequired" style="color: red; margin-right: 5px">**</span>
        <button style="margin: 0; padding: 3px 8px; width: fit-content; white-space: nowrap">{{ placeholder }}</button>
        <div style="width: auto; margin-left: 3px" class="truncate-text">{{ fileDescription }}</div>

        <div v-if="Array.from(selectedFiles).length > 0" class="hover-icon">
          <Tooltip icon="https://dsmlib.logistics.systems/Icons/TooltipInfo.png" :tooltipText="fileNames" />
        </div>

        <div v-if="Array.from(selectedFiles).length > 0" class="hover-icon">
          <Tooltip
            class="close-icon"
            icon="https://dsmapi.logistics.systems/dsm6gIcons/icons8-close-90.png"
            tooltipText="Clear all selected files"
            @click.native="clearAttachmentClicked"
          />
        </div>
      </div>
      <div v-if="fileOver" class="file-drop"> Drop Here </div>
      <input
        type="file"
        class="file-input"
        @change="fileChanged"
        :multiple="multiFile"
        title=""
        @dragover="fileOver = true"
        @drop="fileOver = false"
        @dragleave="fileOver = false"
        ref="fileInput"
      />
    </div>
    <div v-if="errorMessage && textType != 'imageUpload'" class="error-box" :class="[textClass]">
      <div class="error-message" :class="[inputHover ? 'error-message-hover' : '']">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      placeholderAlign: 'flex-start',
      inputIsFocus: false,

      pInputValue: '',
      inputHover: false,

      fileDescription: 'No file selected',
      selectedFiles: [],
      fileOver: false,
    };
  },
  props: {
    textType: { type: String, default: 'text' }, // Change this to password if the input is password
    placeholder: { type: String, default: 'Placeholder' }, // Set the placeholder of the input
    textAlign: { type: String, default: '' }, // Set this to left, center or right
    isRequired: { type: Boolean, default: false }, // Set this to true to indicate this input is required
    inputValue: { type: String, default: '' }, // Bind this value to get the input value
    isDisabled: { type: Boolean, default: false }, // Set this to true to disable any user input
    errorMessage: { type: String, default: '' }, // Set the error message (BETA)
    isContainer: { type: Boolean, default: false }, // Will have the checking to verify the container (BETA)
    isEFTAccountNo: {
      type: Object,
      default: function () {
        return null;
      },
    }, // enable checking for EFT account no. length
    // format_for_EFT_checking: {
    //   swiftCode: "SWIFT Code",         (REQUIRED) // SWIFT code of the bank to check for
    //   paymentType: "FundsTransfer",    (OPTIONAL) // payment type
    //   message: "Custom error message", (OPTIONAL) // custom message to display if account no. entered is not valid
    //   force: false,                    (OPTIONAL) // force user to match the format specified in the JSON file
    //   autoClear: false,                (OPTIONAL) // auto clear user input if user clicks on Edit button
    // }
    // borderWidth: { type: String, default: '0 0 1px 0' }, // Change the border width to the desired border 'top right bottom left'

    fileType: { type: String, default: '' }, // The filetype accepted for textType file
    multiFile: { type: Boolean, default: false }, // Set to true to allow selecting multi files from the input
    whitelistExtension: {
      type: Array,
      default: function () {
        return [];
      },
    }, // To allow blacklist files to be included for texttype file
    // selectedFiles: { type: Array, default: function() { return [] } }, // The array of the selected files

    regex: {
      type: Object,
      default: function () {
        return null;
      },
    }, // To add regex for the input validation
    // Sample for regex is below:
    // {
    //   regex: /^([\da-z\-]{1,})$/gi, // This is a must in a regex format
    //   live: true, // [OPTIONAL] To make sure that the regex is checked when the user is typing
    //   message: 'Please enter only A-Z, numbers and dash(-)', // [OPTIONAL] To show the error message when the regex is not match or defaulted to 'The value is not in correct format'
    //   autoClear: true, // [OPTIONAL] To clear the input value when the regex matching returns null
    //   force: true // [OPTIONAL] To force the user to enter something before proceeding to the next field
    // }

    validator: { type: String, default: '' }, // preset validator function, DO NOT USE TOGETHER WITH REGEX OR CUSTOM VALIDATOR FUNCTION
    // possible string presets: {} = optional parameters; () = default
    //   - alphabetic,{maxLength:Integer},{forceCase:"uppercase"|"lowercase"}
    //   - alphanumeric,{maxLength:Integer},{forceCase:"uppercase"|"lowercase"}
    //   - text,{maxLength:Integer},{forceCase:"uppercase"|"lowercase"},{characterSet:("alphanumeric")|"alphabetic"|"numeric"},{allowedSpecials:"none"|"space"|"dash"|"spacedash"|("all")}
    //   - integer,{maxLength:Integer} // maxLength <= 15
    //   - positiveInteger,{maxLength:Integer} // maxLength <= 15
    //   - negativeInteger,{maxLength:Integer} // maxLength <= 15
    //   - decimal,{maxLength:Integer},{precision:Integer} // maxLength <= 11, precision <= 4
    //   - positiveDecimal,{maxLength:Integer},{precision:Integer} // maxLength <= 11, precision <= 4
    //   - negativeDecimal,{maxLength:Integer},{precision:Integer} // maxLength <= 11, precision <= 4
    //   - weight,{maxLength:Integer} // maxLength <= 11
    //   - volume,{maxLength:Integer} // maxLength <= 11
    //   - currency,{maxLength:Integer} // maxLength <= 11
    //   - positiveCurrency,{maxLength:Integer} // maxLength <= 11
    //   - negativeCurrency,{maxLength:Integer} // maxLength <= 11
    //   - masterfilecode,{maxLength:Integer}
    //   - masterfilename,{maxLength:Integer}
    //  db column datatypes
    //   - money,{fieldType:("currency")|"weight"|"volume"} // default to currency
    //   - positiveMoney,{fieldType:("currency")|"weight"|"volume"} // default to currency
    //   - negativeMoney,{fieldType:("currency")|"weight"|"volume"} // default to currency
    //   - real,{fieldType:"currency"|"weight"|"volume"} // no default for this
    //   - positiveReal,{fieldType:"currency"|"weight"|"volume"} // no default for this
    //   - negativeReal,{fieldType:"currency"|"weight"|"volume"} // no default for this

    // 'real' can only have a total of 7 digits otherwise, it will be stored as scientific notation
    // so Example 5 maxLength 2 precision, or 4 maxLength 3 precision

    //Integers maxLength is capped at 15
    //Deicmals maxLength (whole digits) capped at 11, and precision capped at 4
    //This is to prevent values that is too big for Javascript where it will auto round up or round down values.
    //Technically the cap is closer to 16 digits but it sometimes break at that length. So 15 is a safer number to set it as.
    // Ex: 9999999999999999 will be rounded up to 10000000000000000
    //     99999999999999.99 will be rounded down to 99999999999999.98

    validatorFunction: { type: Function, default: null }, // custom validator function, DO NOT USE TOGETHER WITH REGEX OR PRESET VALIDATOR FUNCTION
    // function signature:
    // function(inputValue: String): Boolean
    // should accept a single string parameter and return a boolean value, will run everytime onInput is fired
    // if a non-boolean value is returned, it will be coerced into a boolean
    // if a falsy value is returned, the inputValue will be reverted to the previous value

    // imgSelected: { type: String, default: '' }, // The base64 of the image selected (textType = imageUpload)
    // imgType: { type: String, default: '' }, // The type/extension of the image (textType = imageUpload)
    // imgWidth: { type: String, default: '200px' }, // The width of the image (textType = imageUpload)
    // imgHeight: { type: String, default: '200px' }, // The height of the image (textType = imageUpload)
    // hasDecimal: { type: Boolean, default: true }, // Set this to false if you don't allow . or decimal place in your input (for textType number only!)

    // public events
    // @focusChanged - fired when the input focused is changed, returns true if the input is focused
    // @enter - fired when 'Enter' key is pressed within the input
    // @down - fired when 'ArrowDown' key is pressed within the input (BETA)
    // @fileChanged - return the array of the files selected along with the placeholder
    // @fileChangedFor - return the placeholder of the changed files to indicate which component trigger the fileChanged event
    // @inputChanged(newValue, oldValue) - fired when the value of the input changes, will not fire if value is changed programatically

    // public methods
    // setFocus() // focuses on the input component
    // selectText() // selects text entered
  },
  computed: {
    textClass: function () {
      switch (this.textAlign) {
        case 'left':
          return 'text-left';
        case 'center':
          return 'text-center';
        case 'right':
          return 'text-right';
        default:
          return 'text-left';
      }
    },
    placeholderClass: function () {
      if (this.inputIsFocus || this.pInputValue) {
        return 'placeholder-top';
      } else {
        return 'placeholder-bottom';
      }
    },
    fileNames: function () {
      let fileNames = Array.from(this.selectedFiles).map((f, i) => `${i + 1}. ${f['name']}`);
      return fileNames.join('\n');
    },
  },
  methods: {
    hasLabelSuffixSlot: function () {
      return (this.$slots['label-suffix'] || []).some((node) => node.tag && !node.isComment);
    },
    inputFocusState: async function (focus) {
      this.inputIsFocus = focus;
      this.$emit('update:errorMessage', '');

      if (!focus) {
        let allowedValidation = ['decimal', 'positiveDecimal', 'negativeDecimal'];
        let isDecimal = allowedValidation.includes(this.validator.split(',')[0]);
        if (isDecimal) {
          if (this.pInputValue === '.') {
            this.pInputValue = '0.';
          } else if (/^\.\d+$/.test(this.pInputValue)) {
            this.pInputValue = '0' + this.pInputValue;
          }
        }
      }

      if (!focus && this.isContainer && this.pInputValue) {
        if (/^[A-Za-z]{4}\d{7}$/.test(this.pInputValue) == false) {
          this.$showAlert(
            'error',
            'Invalid Container Number',
            `Wrong container number format \`<b>${this.pInputValue}</b>\`\nDo not leave any space between characters.\nCorrect format: 4 alphabet follow by 7 digit. `,
          );
          this.setFocus();
          this.selectText();
          return;
        }
        let verify = await this.$apiCallV2(`/ContainerISO/VerifyContNo?contno=${this.pInputValue}`);
        if (!verify['success']) {
          let confirm = await this.$showAlert(
            'warning',
            'Invalid Container Number',
            `Container Number \`<b>${this.pInputValue}</b>\` is not in standard ISO format.\n\nDo you want to continue using this number?`,
            [{ text: `Use ${this.pInputValue}` }, { text: 'Edit Container Number', color: 'gray', textColor: 'white' }],
          );

          if (confirm.includes('Edit')) {
            this.setFocus();
            this.selectText();
          }
        }
      }

      if (!focus && this.isEFTAccountNo && this.pInputValue) {
        // on blur, isEFTAccountNo is not null, pInputValue is not blank
        const validationResult = await this.$apiCallV2(
          `/EFTBankAccountFormat/ValidateAccountFormat?swiftCode=${this.isEFTAccountNo['swiftCode'].trim()}${this.isEFTAccountNo['paymentType'] ? `&paymentType=${this.isEFTAccountNo['paymentType'].trim()}` : ''}&inputValue=${this.pInputValue}`,
        );
        if (validationResult !== null && !validationResult['valid']) {
          // the controller returns null if it can't find the format
          let message;
          if (this.isEFTAccountNo['message']) {
            // if a custom message was passed
            message = this.isEFTAccountNo['message']; // display the custom message
          } else {
            // else format the default message
            message = 'Account no. ';
            if (this.isEFTAccountNo['paymentType']) {
              message += `for ${this.isEFTAccountNo['paymentType']} to<br>${validationResult['BankName']}<br>should be `;
            } else {
              message += `for<br>${validationResult['BankName']}<br>should be `;
            }

            let lengthLimitationSet = new Set(); // using a Set to remove duplicates
            let rangeLimitationSet = new Set(); // using a Set to remove duplicates
            for (const key in validationResult) {
              if (key === 'BankName' || key === 'valid') {
                continue; // ignore this key and go to the next
              }

              if (validationResult[key] instanceof Object) {
                if (Object.hasOwn(validationResult[key], 'Length')) {
                  for (const length of validationResult[key]['Length']) {
                    lengthLimitationSet.add(length);
                  }
                }
                if (Object.hasOwn(validationResult[key], 'Range')) {
                  for (const range of validationResult[key]['Range']) {
                    lengthLimitationSet.add(range);
                  }
                }
              }
            }

            let combinedLimitations = Array.from(lengthLimitationSet);
            combinedLimitations.sort((a, b) => {
              // sort in ascending order
              return a > b ? 1 : -1;
            });
            combinedLimitations = combinedLimitations.concat(Array.from(rangeLimitationSet));
            let lastLimitation = combinedLimitations.pop();
            message +=
              combinedLimitations.length > 0 ?
                `${combinedLimitations.join(', ')} or ${lastLimitation} `
              : `${lastLimitation} `;
            message += `characters long`;
          }

          let buttons =
            (
              this.isEFTAccountNo['force'] // if force is true
            ) ?
              [{ text: 'Edit Account No.' }] // force the user to edit the input until it matches the specified format
            : [
                // else allow them to proceed even if the format is incorrect
                { text: 'Use Incorrect Format', color: 'indianred', textColor: 'white' },
                { text: 'Edit Account No.' },
              ];

          const proceed = await this.$showAlert('warning', 'Invalid Account No.', message, buttons);
          if (proceed === 'Edit Account No.') {
            if (this.isEFTAccountNo['autoClear']) {
              this.pInputValue = '';
            }
            this.setFocus();
            this.selectText();
          }
        }
      }

      if (!focus && this.regex && this.pInputValue && this.textType == 'text') {
        let matches = this.pInputValue.match(this.regex['regex']);
        if (!matches) {
          let buttons = [];
          if (this.regex['force']) {
            buttons = [{ text: 'Edit Value' }];
          } else {
            buttons = [
              { text: 'Use Incorrect Format', color: 'indianred', textColor: 'white' },
              { text: 'Edit Value' },
            ];
          }

          let incorrectButton = await this.$showAlert(
            'error',
            'Incorrect Format',
            this.regex['message'] || 'The value is not in correct format',
            buttons,
          );
          if (incorrectButton == 'Edit Value') {
            if (this.regex['autoClear']) {
              this.pInputValue = '';
            }
            this.setFocus();
          }
        }
      }

      this.$emit('focusChanged', focus);
    },
    fileChanged: async function (e) {
      let files = e.target.files;
      if (files.length > 0) {
        let blacklistList = await this.$apiCallV2('/File/GetFile?fileName=BlacklistFilesList.json');
        let selectedFileExtensions = Array.from(files).map((f) => {
          let nameSplit = f.name.split('.');
          return {
            fileName: f.name,
            extension: nameSplit[nameSplit.length - 1],
          };
        });

        let selectedIsBlacklist = selectedFileExtensions
          .filter((s) => {
            if (blacklistList.includes(s['extension']) && !this.whitelistExtension.includes(s['extension'])) {
              return s;
            }
          })
          .map((s, i) => `${i + 1}. ${s['fileName']}`);

        if (selectedIsBlacklist.length > 0) {
          this.$showAlert(
            'error',
            'File Not Allowed',
            `We're sorry but there is one or more file that you've selected is not allowed.
The file(s) which is not allowed are;
${selectedIsBlacklist.join('<br>')}

Please select your file(s) again.`,
          );

          this.clearAttachmentClicked();
          return;
        }

        this.selectedFiles = files;
        if (files.length == 1) {
          this.fileDescription = files[0].name;
        } else {
          this.fileDescription = `${files.length} files selected`;
        }
        this.$emit('fileChanged', files, this.placeholder);
      } else if (!this.selectedFiles) {
        this.fileDescription = 'No file selected';
        this.$emit('fileChanged', files, this.placeholder);
      }
    },
    clearAttachmentClicked: function () {
      // Clears input to make sure @change triggers
      this.$nextTick(() => {
        this.$refs['fileInput'].value = '';
      });
      this.fileDescription = 'No file selected';
      this.selectedFiles = [];
      this.$emit('fileChanged', [], this.placeholder);
    },
    inputKeyState: function (e, state) {
      if (state == 'keyup') {
        this.$emit('keyup', e);
      } else {
        this.$emit('keyDown', e);

        if (this.textType == 'number') {
          if (e.key == 'ArrowUp' || e.key == 'ArrowDown') {
            e.preventDefault();
          } else if (e.key == 'e') {
            e.preventDefault();
          }
        }
      }
    },
    setFocus: function () {
      // public method
      this.$refs.myinput.focus();
    },
    setBlur: function () {
      // public method
      this.$refs.myinput.blur();
    },
    selectText: function () {
      // public method
      this.$refs.myinput.select();
    },
    inputChanged: function (e) {
      // this event only fires when the user enters something into the input field
      // it does not fire if any of the inputValues were changed programatically

      this.pInputValue = this.pInputValue.replaceAll(/[^ -~]/g, ''); // remove all non-ASCII characters

      if (!this.pInputValue) {
        this.$emit('inputChanged', this.pInputValue, this.inputValue); // emit new value and old value
        return;
      }

      if (this.regex?.['live']) {
        let match = this.pInputValue.match(this.regex['regex']);
        if (match) {
          this.pInputValue = match.join('');
        } else {
          this.pInputValue = '';
        }
      } else if (this.validator) {
        let [datatype, modifier1, modifier2, modifier3, modifier4] = this.validator.split(',');
        const selectionStart = this.$refs.myinput.selectionStart;
        const selectionEnd = this.$refs.myinput.selectionEnd;

        let valid = true;
        switch (datatype) {
          case 'alphabetic': // modifier1 = maxLength, modifier2 = forceCase
            valid = this.validateAlphabetic(this.pInputValue, modifier1);
            break;

          case 'alphanumeric': // modifier1 = maxLength, modifier2 = forceCase
            valid = this.validateAlphanumeric(this.pInputValue, modifier1);
            break;

          case 'text': // modifier1 = maxLength, modifier2 = forceCase, modifier3 = characterSet, modifier4 = allowedSpecials
            valid = this.validateText(this.pInputValue, modifier1, modifier3, modifier4);
            break;

          case 'integer': // modifier1 = maxLength
            valid = this.validateInteger(this.pInputValue, modifier1);
            break;

          case 'positiveInteger': // modifier1 = maxLength
            valid = this.validatePositiveInteger(this.pInputValue, modifier1);
            break;

          case 'negativeInteger': // modifier1 = maxLength
            valid = this.validateNegativeInteger(this.pInputValue, modifier1);
            break;

          case 'decimal': // modifier1 = maxLength, modifier2 = precision
            valid = this.validateDecimal(this.pInputValue, modifier1, modifier2);
            break;

          case 'positiveDecimal': // modifier1 = maxLength, modifier2 = precision
            valid = this.validatePositiveDecimal(this.pInputValue, modifier1, modifier2);
            break;

          case 'negativeDecimal': // modifier1 = maxLength, modifier2 = precision
            valid = this.validateNegativeDecimal(this.pInputValue, modifier1, modifier2);
            break;

          case 'weight': // modifier1 = maxLength, modifier2 = precision from API
            valid = this.validatePositiveDecimal(
              this.pInputValue,
              modifier1,
              this.$store.state.weightFormat.substring(2),
            );
            break;

          case 'volume': // modifier1 = maxLength, modifier2 = precision from API
            valid = this.validatePositiveDecimal(
              this.pInputValue,
              modifier1,
              this.$store.state.volumeFormat.substring(2),
            );
            break;

          case 'currency': // modifier1 = maxLength, modifier2 = precision from API
            valid = this.validateDecimal(this.pInputValue, modifier1, this.$store.state.currencyFormat.substring(2));
            break;

          case 'positiveCurrency': // modifier1 = maxLength, modifier2 = precision from API
            valid = this.validatePositiveDecimal(
              this.pInputValue,
              modifier1,
              this.$store.state.currencyFormat.substring(2),
            );
            break;

          case 'negativeCurrency': // modifier1 = maxLength, modifier2 = precision from API
            valid = this.validateNegativeDecimal(
              this.pInputValue,
              modifier1,
              this.$store.state.currencyFormat.substring(2),
            );
            break;

          case 'masterfilecode': // modifier1 = maxLength
            valid = this.validateMasterFileCode(this.pInputValue, modifier1);
            modifier2 = 'uppercase'; //masterfilecode should always force codes to upper case
            break;

          case 'masterfilename': // modifier1 = maxLength
            valid = this.validateText(this.pInputValue, modifier1, 'alphanumeric', 'all');
            if (this.$store.state.masterFileNameFormat.toUpper) modifier2 = 'uppercase';
            break;

          case 'money': //modifier1 = fieldType
            const moneyFieldType = modifier1 || 'currency';
            if (moneyFieldType === 'currency')
              valid = this.validateDecimal(this.pInputValue, 11, this.$store.state.currencyFormat.substring(2));
            else if (moneyFieldType === 'weight')
              valid = this.validateDecimal(this.pInputValue, 11, this.$store.state.weightFormat.substring(2));
            else if (moneyFieldType === 'volume')
              valid = this.validateDecimal(this.pInputValue, 11, this.$store.state.volumeFormat.substring(2));
            break;

          case 'positiveMoney': //modifier1 = fieldType
            const positiveMoneyFieldType = modifier1 || 'currency';
            if (positiveMoneyFieldType === 'currency')
              valid = this.validatePositiveDecimal(this.pInputValue, 11, this.$store.state.currencyFormat.substring(2));
            else if (positiveMoneyFieldType === 'weight')
              valid = this.validatePositiveDecimal(this.pInputValue, 11, this.$store.state.weightFormat.substring(2));
            else if (positiveMoneyFieldType === 'volume')
              valid = this.validatePositiveDecimal(this.pInputValue, 11, this.$store.state.volumeFormat.substring(2));
            break;

          case 'negativeMoney': //modifier1 = fieldType
            const negativeMoneyFieldType = modifier1 || 'currency';
            if (negativeMoneyFieldType === 'currency')
              valid = this.validateNegativeDecimal(this.pInputValue, 11, this.$store.state.currencyFormat.substring(2));
            else if (negativeMoneyFieldType === 'weight')
              valid = this.validateNegativeDecimal(this.pInputValue, 11, this.$store.state.weightFormat.substring(2));
            else if (negativeMoneyFieldType === 'volume')
              valid = this.validateNegativeDecimal(this.pInputValue, 11, this.$store.state.volumeFormat.substring(2));
            break;

          case 'real': //modifier1 = fieldType
            const realFieldType = modifier1 || undefined;
            if (realFieldType === 'currency')
              valid = this.validateDecimal(
                this.pInputValue,
                7 - this.$store.state.currencyFormat.substring(2),
                this.$store.state.currencyFormat.substring(2),
              );
            else if (realFieldType === 'weight')
              valid = this.validateDecimal(
                this.pInputValue,
                7 - this.$store.state.weightFormat.substring(2),
                this.$store.state.weightFormat.substring(2),
              );
            else if (realFieldType === 'volume')
              valid = this.validateDecimal(
                this.pInputValue,
                7 - this.$store.state.volumeFormat.substring(2),
                this.$store.state.volumeFormat.substring(2),
              );
            else valid = this.validateDecimal(this.pInputValue, 5, 2);
            break;

          case 'positiveReal': //modifier1 = fieldType
            const positiveRealFieldType = modifier1 || undefined;
            if (positiveRealFieldType === 'currency')
              valid = this.validatePositiveDecimal(
                this.pInputValue,
                7 - this.$store.state.currencyFormat.substring(2),
                this.$store.state.currencyFormat.substring(2),
              );
            else if (positiveRealFieldType === 'weight')
              valid = this.validatePositiveDecimal(
                this.pInputValue,
                7 - this.$store.state.weightFormat.substring(2),
                this.$store.state.weightFormat.substring(2),
              );
            else if (positiveRealFieldType === 'volume')
              valid = this.validatePositiveDecimal(
                this.pInputValue,
                7 - this.$store.state.volumeFormat.substring(2),
                this.$store.state.volumeFormat.substring(2),
              );
            else valid = this.validatePositiveDecimal(this.pInputValue, 5, 2);
            break;

          case 'negativeReal': //modifier1 = fieldType
            const negativeRealFieldType = modifier1 || undefined;
            if (negativeRealFieldType === 'currency')
              valid = this.validateNegativeDecimal(
                this.pInputValue,
                7 - this.$store.state.currencyFormat.substring(2),
                this.$store.state.currencyFormat.substring(2),
              );
            else if (negativeRealFieldType === 'weight')
              valid = this.validateNegativeDecimal(
                this.pInputValue,
                7 - this.$store.state.weightFormat.substring(2),
                this.$store.state.weightFormat.substring(2),
              );
            else if (negativeRealFieldType === 'volume')
              valid = this.validateNegativeDecimal(
                this.pInputValue,
                7 - this.$store.state.volumeFormat.substring(2),
                this.$store.state.volumeFormat.substring(2),
              );
            else valid = this.validateNegativeDecimal(this.pInputValue, 5, 2);
            break;
        }

        if (!valid) {
          // invalid input
          const charactersDifference = this.pInputValue.length - this.inputValue.length; // new value length - old value length
          this.pInputValue = this.inputValue; // revert to previous value

          this.$nextTick(() => {
            // reset cursor to previous position
            this.$refs.myinput.setSelectionRange(
              selectionStart - charactersDifference,
              selectionEnd - charactersDifference,
            );
          });
        } else if (modifier2 === 'uppercase') {
          this.pInputValue = this.pInputValue.toUpperCase();

          this.$nextTick(() => {
            // reset cursor to previous position
            this.$refs.myinput.setSelectionRange(selectionStart, selectionEnd);
          });
        } else if (modifier2 === 'lowercase') {
          this.pInputValue = this.pInputValue.toLowerCase();

          this.$nextTick(() => {
            // reset cursor to previous position
            this.$refs.myinput.setSelectionRange(selectionStart, selectionEnd);
          });
        }
      } else if (this.validatorFunction) {
        const valid = this.validatorFunction(this.pInputValue);

        if (!valid) {
          const selectionStart = this.$refs.myinput.selectionStart;
          const selectionEnd = this.$refs.myinput.selectionEnd;
          const charactersDifference = this.pInputValue.length - this.inputValue.length; // new value length - old value length

          this.pInputValue = this.inputValue; // revert to previous value
          this.$nextTick(() => {
            // reset cursor to previous position
            this.$refs.myinput.setSelectionRange(
              selectionStart - charactersDifference,
              selectionEnd - charactersDifference,
            );
          });
        }
      }

      this.$emit('inputChanged', this.pInputValue, this.inputValue); // emit new value and old value
    },
    validateAlphabetic: function (inputValue, maxLength) {
      if (maxLength && inputValue.length > maxLength) {
        return false; // input not valid
      }

      return inputValue.match(/^[A-Za-z]+$/);
    },
    validateAlphanumeric: function (inputValue, maxLength) {
      if (maxLength && inputValue.length > maxLength) {
        return false; // input not valid
      }

      return inputValue.match(/^[A-Za-z0-9]+$/);
    },
    validateText: function (inputValue, maxLength, characterSet, allowedSpecials) {
      if (maxLength && inputValue.length > maxLength) {
        return false; // input not valid
      }

      let regexPattern = '^[';
      switch (characterSet) {
        case 'alphabetic':
          regexPattern += 'A-Za-z';
          break;

        case 'numeric':
          regexPattern += '0-9';
          break;

        case 'alphanumeric':
        default:
          regexPattern += 'A-Za-z0-9';
          break;
      }

      switch (allowedSpecials) {
        case 'none': // no special characters allowed
          // do nothing, leave regexPattern as is
          break;

        case 'space': // only space allowed
          regexPattern += ' '; // match space
          break;

        case 'dash':
          regexPattern += '\\-'; // match dash
          break;

        case 'spacedash':
          regexPattern += ' \\-'; // match space or dash
          break;

        case 'all': // all special characters allowed
        default:
          regexPattern += '\\W_'; // match all non-word characters and underscore
          break;
      }

      regexPattern += ']+$';
      return inputValue.match(new RegExp(regexPattern));
    },
    validateInteger: function (inputValue, modifierMaxLength = 15) {
      const hardMaxLength = 15;
      const maxLength = Math.min(modifierMaxLength, hardMaxLength); //chooses the smallest number, so if modifier > hardMax, it will choose hardMax

      if (inputValue.startsWith('-') && inputValue.length - 1 > maxLength) {
        // if there is a negative symbol, don't include it in the length check
        return false; // input not valid
      }

      if (!inputValue.startsWith('-') && inputValue.length > maxLength) {
        return false; // input not valid
      }

      return inputValue.match(/^-?\d*$/); // can either start with a negative or not, and must only contain digits after that
    },
    validatePositiveInteger: function (inputValue, modifierMaxLength = 15) {
      const hardMaxLength = 15;
      const maxLength = Math.min(modifierMaxLength, hardMaxLength); //chooses the smallest number, so if modifier > hardMax, it will choose hardMax

      if (inputValue.length > maxLength) {
        return false; // input not valid
      }

      return inputValue.match(/^\d+$/); // entire string must only contain digits
    },
    validateNegativeInteger: function (inputValue, modifierMaxLength = 15) {
      const hardMaxLength = 15;
      const maxLength = Math.min(modifierMaxLength, hardMaxLength); //chooses the smallest number, so if modifier > hardMax, it will choose hardMax

      if (inputValue.length - 1 > maxLength) {
        // will always start with a negative symbol, exclude it from the length check
        return false; // input not valid
      }

      return inputValue.match(/^-\d*$/); // must start with a negative, and must only contain digits after that
    },
    validateDecimal: function (inputValue, modifierMaxLength = 11, modifierPrecision = 4) {
      const hardMaxLength = 11;
      const maxLength = Math.min(modifierMaxLength, hardMaxLength); //chooses the smallest number, so if modifier > hardMax, it will choose hardMax

      const hardMaxPrecision = 4;
      const precision = Math.min(modifierPrecision, hardMaxPrecision); //chooses the smallest number, so if modifier > hardMax, it will choose hardMax

      const [whole, decimal] = inputValue.split('.');

      if (maxLength) {
        // maxLength is not undefined or null or 0
        if (whole.startsWith('-') && whole.length - 1 > maxLength) {
          // if there is a negative symbol, don't include it in the length check
          return false; // input not valid
        } else if (!whole.startsWith('-') && whole.length > maxLength) {
          return false; // input not valid
        }
      }

      if (precision && decimal?.length > precision) {
        return false; // input not valid
      }

      return inputValue.match(/^-?\d*\.?\d*$/);
    },
    validatePositiveDecimal: function (inputValue, modifierMaxLength = 11, modifierPrecision = 4) {
      const hardMaxLength = 11;
      const maxLength = Math.min(modifierMaxLength, hardMaxLength); //chooses the smallest number, so if modifier > hardMax, it will choose hardMax

      const hardMaxPrecision = 4;
      const precision = Math.min(modifierPrecision, hardMaxPrecision); //chooses the smallest number, so if modifier > hardMax, it will choose hardMax

      const [whole, decimal] = inputValue.split('.');

      if (maxLength && whole.length > maxLength) {
        return false; // input not valid
      }

      if (precision && decimal?.length > precision) {
        return false; // input not valid
      }

      return inputValue.match(/^\d*\.?\d*$/);
    },
    validateNegativeDecimal: function (inputValue, modifierMaxLength = 11, modifierPrecision = 4) {
      const hardMaxLength = 11;
      const maxLength = Math.min(modifierMaxLength, hardMaxLength); //chooses the smallest number, so if modifier > hardMax, it will choose hardMax

      const hardMaxPrecision = 4;
      const precision = Math.min(modifierPrecision, hardMaxPrecision); //chooses the smallest number, so if modifier > hardMax, it will choose hardMax

      const [whole, decimal] = inputValue.split('.');

      if (maxLength && whole.length - 1 > maxLength) {
        // will always start with a negative symbol, exclude it from the length check
        return false; // input not valid
      }

      if (precision && decimal?.length > precision) {
        return false; // input not valid
      }

      return inputValue.match(/^-\d*\.?\d*$/);
    },

    validateMasterFileCode: function (inputValue, maxLength) {
      if (maxLength && inputValue.length > maxLength) {
        return false; // input not valid
      }

      if (this.$store.state.masterCodeFileFormat.noSpace) {
        //1 = No space in Master code
        if (inputValue.includes(' ')) return false;
      }

      return inputValue.match(/^[^"']+$/); // input cannot have single and double quotes
    },
  },
  mounted() {
    if (this.inputValue) {
      this.pInputValue = this.inputValue;
    }

    if (this.errorMessage) {
      this.privateErrorMessage = this.errorMessage;
    }
  },
  watch: {
    textAlign: function (val) {
      switch (val) {
        case 'left':
          this.placeholderAlign = 'flex-start';
          break;
        case 'center':
          this.placeholderAlign = 'center';
          break;
        case 'right':
          this.placeholderAlign = 'flex-end';
          break;
      }
    },
    pInputValue: function (val) {
      this.$emit('update:inputValue', val);
    },
    inputValue: function (val) {
      this.pInputValue = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.input-main {
  width: 100%;
  position: relative;
  height: 25px;
  padding: 0;
  display: flex;
  margin: 2px 0px;
  // background-color: green;

  > .placeholder {
    position: absolute;
    display: flex;
    // background-color: red;
    pointer-events: none;
    height: 100%;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    align-items: center;
    transition: 0.3s;
    opacity: 0.6;
    top: -1px;
    font-size: 12px;

    > .no-wrap {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &.has-label-suffix {
        display: flex;
        align-items: center;

        > :not(:first-child) {
          flex: 0 0 auto;
        }
      }
    }
  }

  > .placeholder-top {
    top: -12px;
    font-size: 8px;
    opacity: 1;
  }

  > .placeholder-bottom {
    top: -1px;
    font-size: 12px;
    opacity: 0.6;
  }

  > .input-control > .text-left {
    justify-content: flex-start;
    text-align: left;
  }

  > .input-control > .text-center {
    justify-content: center;
    text-align: center;
  }

  > .input-control > .text-right {
    justify-content: flex-end;
    text-align: right;
  }

  > .input-control {
    display: contents;
  }

  > .input-control > input[type='text'],
  > .input-control > input[type='password'],
  > .input-control > input[type='number'] {
    width: 100%;
    height: 20px;
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: rgba(128, 128, 128, 0.5);
    background-color: transparent;
    position: relative;
    font-size: 12px;
    transition: $transition-time;
    top: -3px;
    // padding: 7px 10px;
    padding: 14px 10px 9px 10px;
  }

  > .input-control > input::-webkit-outer-spin-button,
  > .input-control > input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  > .input-control > input[type='number'] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  > .input-control > input:disabled {
    opacity: 1;
    background-color: rgba(200, 200, 200, 0.2);
    color: black;
    -webkit-text-fill-color: black;
  }

  > .input-control > input:focus {
    outline: none;
    border-color: black;
  }

  > .error-box {
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 12px;
    top: -3px;
    pointer-events: none;

    > .error-message {
      background-color: red;
      color: white;
      padding: 1px 5px;
      border-radius: 5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > .error-message-hover {
      overflow: visible;
      z-index: 111;
      border: 1px solid black;
    }
  }

  > .file-area {
    font-size: 12px;
    position: relative;
    width: fit-content; // if it's a file input, don't take up the entire containing div's width if it's not necessary, so that there's no trailing whitespace for the user to click on, which would normally open the file browser
    max-width: 100%; // don't let it overflow beyond the containing div's width as well
    // overflow: hidden;

    > .file-disabled {
      background-color: rgba(200, 200, 200, 0.15);
      z-index: 99;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    > .file-input {
      cursor: pointer;
      opacity: 0;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    > .file-input::-webkit-file-upload-button {
      background-color: $btn-color;
      transition: $transition-time;
      padding: 5px 10px;
      border: none;
      border-radius: 3px;
      cursor: pointer;
    }

    > .file-input::-webkit-file-upload-button:hover {
      background-color: $btn-color-hover;
    }

    > .file-input::-webkit-file-upload-button:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.3);
    }

    > .upload-area {
      position: relative;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;

      > .hover-icon {
        position: relative;
        display: flex;
        align-items: center;
        z-index: 1;
        padding-left: 5px;
        /* background: red; */

        > .close-icon {
          cursor: pointer;
        }
      }
    }

    > .file-drop {
      display: flex;
      align-items: center;
      font-weight: bolder;
      background-color: white;
      border: 1px solid black;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding-left: 5px;
    }
  }
}
</style>
